import Head from "@helper/seo/head";
import React from "react";
import Layout from "@/landing/template/about";
import getContents from "@helper/util/landing/getContents";

function Landing() {
  const { contents } = getContents();
  return (
    <>
      <Head
        title="SellOn | About"
        catchme=""
      />
      <Layout contents={contents} />
    </>
  );
}

export default Landing;
